export default __webpack_public_path__ + "static/media/stylelint.702babab.svg";